/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Popconfirm } from 'antd';
import {
  CloseOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './style.scss';
import { QUANTITY } from '@Apis/constants';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import ProductCategoryLabel from '@Components/Common/ProductCategoryLabel';
import FGInwardBatch from '@Components/Production/ManualProductionEntry/ManualProductionEntryForm/FGInwardBatch';
import BatchCustomFields from '../../../../../Common/BatchCustomFields';

/**
 *
 */
class ByProduct extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      productListColumns: [
        {
          title: 'PRODUCT',
          width: '350px',
          render: (text, record) => {
            const {
              handleProductChangeValue, handleProductChange, formSubmitted, excludedProducts, data, tenantDepartmentId,
            } = this.props;
            return (
              <div className="mo-bp-table__product-name">
                {
                  record?.bomByProductId || record?.by_product_id ? (
                    <Fragment>
                      <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`} target="_blank">
                        {`#${record?.tenant_product_info?.internal_sku_code}`}
                      </Link>
                      <div>
                        {record?.productSkuName}
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <ProductFilterV2
                        record={record}
                        productTypes={['STORABLE', 'SERVICE']}
                        handleProductChangeValue={handleProductChangeValue}
                        handleProductChange={handleProductChange}
                        required
                        showError={formSubmitted && !record.productSkuName}
                        onClear={(key) => {
                          const { updateData } = this.props;
                          const copyData = JSON.parse(JSON.stringify(data));
                          const newData = copyData.map((item) => {
                            if (item.key === key) {
                              return {
                                key: uuidv4(),
                                asset1: '',
                                productSkuName: '',
                                quantity: '',
                                unitPrice: '',
                                taxId: '',
                                lot: '',
                              };
                            }
                            return {
                              ...item,
                            };
                          });
                          updateData(newData);
                        }}
                        excludedProducts={excludedProducts}
                        tenantDepartmentId={tenantDepartmentId}
                      />
                    </Fragment>
                  )
                }
                {record?.product_category_info?.category_path?.length > 0 && (
                  <ProductCategoryLabel
                    categoryPath={record?.product_category_info?.category_path}
                    categoryName={record?.product_category_info?.category_path?.at(-1)}
                    containerStyle={{
                      width: 'fit-content',
                    }}
                  />
                )}
              </div>
            );
          },
        },
        {
          title: 'QUANTITY',
          width: '180px',
          render: (text, record) => {
            const {
              createMOLoading, updateMOLoading, formSubmitted, handleQuantityChange, multipleFG,
            } = this.props;
            return (multipleFG ? (
              <Fragment>
                {`${QUANTITY(record?.estimatedUsage, record?.uomInfo?.precision)} ${record?.uomInfo?.uqc?.toProperCase()}`}
              </Fragment>
            )
              : (
                <div className="mo-fg-table__quantity">
                  <H3FormInput
                    name="a valid quantity"
                    type="number"
                    containerClassName="orgInputContainer mo-form__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => {
                      handleQuantityChange(record?.fg_tenant_product_id, e.target.value, record?.key);
                    }}
                    value={record?.estimatedUsage}
                    showError={formSubmitted && !Number(record?.estimatedUsage)}
                    disabled={createMOLoading || updateMOLoading}
                    loading={createMOLoading || updateMOLoading}
                  />
                  <H3Text text={record?.tenant_product_info?.uom_info?.uqc?.toProperCase()} className="mo-fg-table__quantity-unit" />
                </div>
              )
            );
          },
        },
        {
          title: 'BATCH INFO',
          width: '250px',
          render: (item) => {
            const {
              user, tenantDepartmentId, data, updateData, formSubmitted, setIsBatchValid,
            } = this.props;

            const enabledLocationBasedStock = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
            const enabledWarehouseLocations = user?.tenant_info?.global_config?.sub_modules?.warehouse_setup?.is_active;

            return (
              <FGInwardBatch
                item={item}
                formSubmitted={formSubmitted}
                data={data}
                updateData={(value) => updateData({
                  [value?.[0]?.fg_tenant_product_id]: value,
                })}
                destDepartmentId={tenantDepartmentId}
                enabledWarehouseLocations={enabledWarehouseLocations && enabledLocationBasedStock}
                setIsBatchValid={setIsBatchValid}
                hideCost
              />
            );
          },
        },
        {
          title: 'BATCH CUSTOM FIELDS',
          width: '236px',
          render: (item) => {
            
            const { formSubmitted, } = this.props;
        
            return (
              <Fragment>
                <BatchCustomFields
                  cfWrapperClassName="create-grn__input-row"
                  labelClassName="create-grn__input-row__label"
                  customFields={item?.selectedBatch?.custom_fields || []}
                  formSubmitted={formSubmitted}
                  customInputChange={(value, cfId) => this.updateBatchCfs(value, cfId, item)}
                  isHorizontalUi
                  hideTitle
                />
              </Fragment>
            )
          },
        },
        {
          title: ' ',
          width: '40px',
          render: (text, record) => {
            const { handleDelete } = this.props;
            return (
              <Fragment>
                <Popconfirm
                  title="Confirm remove By Products?"
                  onConfirm={() => handleDelete(record?.product_sku_id, record.key)}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No"
                >
                  <div className="create-mo-bp__delete-line-button">
                    <CloseOutlined />
                  </div>
                </Popconfirm>
              </Fragment>
            );
          },
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource(data) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return [];
  }
  
  updateBatchCfs = (fieldValue, cfId, record) => {
    
    const { data, updateData, } = this.props;
    const copyData = JSON.parse(JSON.stringify(data));
    
    for (const item of copyData) {

      if(record?.key === item?.key && item?.key) {
        
        const copyLineCfs = item?.selectedBatch?.custom_fields;
        for (const cf of copyLineCfs) {
          
          if (cf.cfId === cfId) {
            
            cf.fieldValue = cf.fieldType === 'ATTACHMENT' ? fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url,
              type: attachment?.type,
              name: attachment?.name,
              uid: attachment?.uid,
            })) : fieldValue;
            break;
          }
        }
        break;
      }
    }
    updateData({[copyData?.[0]?.fg_tenant_product_id]: copyData});
  };

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      data, loading, isFlexible,
    } = this.props;
    const {
      productListColumns,
    } = this.state;
    return (
      <Fragment>
        <div className="bp-table-wrapper">
          <Table
            bordered
            loading={loading}
            showHeader
            size="small"
            columns={isFlexible ? productListColumns : productListColumns?.filter((item) => item.title)}
            dataSource={data}
            pagination={false}
          />
        </div>

      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

ByProduct.propTypes = {
  loading: PropTypes.bool,
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  formSubmitted: PropTypes.bool,
  addNewRow: PropTypes.func,
  isFlexible: PropTypes.bool,
  createMOLoading: PropTypes.bool,
  updateMOLoading: PropTypes.bool,
  multipleFG: PropTypes.bool,
  handleQuantityChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ByProduct));
